export default __webpack_public_path__ + "static/1-f0f45de409df5893fd95f61b1a432872.png";